/* ==========================================================================
   Off-canvas Drawer + Accordion (no jQuery)
   Requires:
   - #open-nav button (hamburger)
   - #close-nav button inside drawer
   - #off-canvas element with class "drawer"
   - #backdrop element (.body-backdrop)
   - Menu markup with .menu-item-has-children
   -------------------------------------------------------------------------- */

(function() {
  const openBtn   = document.getElementById('open-nav');
  const closeBtn  = document.getElementById('close-nav');
  const drawer    = document.getElementById('off-canvas');
  const backdrop  = document.getElementById('backdrop');
  const body      = document.body;

  if (!openBtn || !closeBtn || !drawer || !backdrop) return;

  /* Helpers */
  const openDrawer = () => {
    drawer.classList.add('is-open');
    backdrop.classList.add('is-open');
    body.classList.add('no-scroll');
    openBtn.setAttribute('aria-expanded', 'true');
    drawer.setAttribute('aria-hidden', 'false');

    // focus trap start
    setTimeout(() => {
      const firstFocusable = drawer.querySelector('a, button, [tabindex]:not([tabindex="-1"])');
      firstFocusable && firstFocusable.focus();
    }, 10);
    document.addEventListener('keydown', onKeydown);
  };

  const closeDrawer = () => {
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    body.classList.remove('no-scroll');
    openBtn.setAttribute('aria-expanded', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    document.removeEventListener('keydown', onKeydown);
    openBtn.focus();
  };

  const onKeydown = (e) => {
    if (e.key === 'Escape') { closeDrawer(); }
  };

  openBtn.addEventListener('click', openDrawer);
  closeBtn.addEventListener('click', closeDrawer);
  backdrop.addEventListener('click', closeDrawer);

  /* Accordion (click to open; no instant hover) */
  drawer.addEventListener('click', (e) => {
    const trigger = e.target.closest('.menu-item-has-children > a');
    if (!trigger) return;

    const li = trigger.parentElement;

    // First tap opens; prevent navigation only when closed
    if (!li.classList.contains('show-sub')) {
      e.preventDefault();
    }

    // Close siblings at same level
    li.parentElement.querySelectorAll(':scope > .menu-item-has-children.show-sub').forEach(sib => {
      if (sib !== li) sib.classList.remove('show-sub');
    });

    // Toggle current
    li.classList.toggle('show-sub');
  });
})();

// Desktop mega/flyout hover intent (keeps submenus open while you move the mouse)
(() => {
  const root = document.querySelector('.header__nav .header__menu');
  if (!root) return;

  const HOVERS_OK = matchMedia('(hover:hover)').matches && matchMedia('(pointer:fine)').matches;
  const OPEN = 'is-open';
  const ENTER_DELAY = 50;    // ms before opening
  const LEAVE_DELAY = 180;   // ms before closing (gives you time to travel)

  let openTimer = null, closeTimer = null, current = null;

  const open = (li) => {
    clearTimeout(closeTimer);
    if (current && current !== li) current.classList.remove(OPEN);
    li.classList.add(OPEN);
    current = li;
  };

  const close = (li) => {
    li.classList.remove(OPEN);
    if (current === li) current = null;
  };

  root.querySelectorAll('li.menu-item-has-children').forEach((li) => {
    // Mouse: delayed open/close for hover gaps
    if (HOVERS_OK) {
      li.addEventListener('mouseenter', () => {
        clearTimeout(openTimer);
        openTimer = setTimeout(() => open(li), ENTER_DELAY);
      });
      li.addEventListener('mouseleave', () => {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => close(li), LEAVE_DELAY);
      });
    }

    // Keyboard: open on focus within, close when focus leaves the subtree
    li.addEventListener('focusin', () => open(li));
    li.addEventListener('focusout', (e) => {
      if (!li.contains(e.relatedTarget)) close(li);
    });
  });

  // Close everything on ESC
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && current) close(current);
  });
})();

